import { useQuery } from "@tanstack/react-query";
import { getProductCatalogueHeaderModel } from "../../../../api/headerApi";

export const useCatalogueHeaderModel = ( currentPageId: string ) => {
  return useQuery({
    queryKey: ["redesign-catalogue-header"],
    queryFn: () => getProductCatalogueHeaderModel(currentPageId),
    staleTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });
}
